module.exports = __webpack_public_path__ + "img/food_02.0d39531e.jpg";